// axios
import axios from "axios";

export const baseURL = "https://i-see.iconpln.co.id/backend/api";
//export const baseURL = "/api";

export const init = () => {
  return axios.create({
    baseURL: baseURL,
    // You can add your headers here
  });
};

export const setAuthorizationHeader = (instance) => {
  const accessToken = localStorage.getItem("accessToken");
  console.log(accessToken)
  if (accessToken) {
  console.log("Use Access Token On Request")
    // Set the AUTH token for any request
    instance.interceptors.request.use(function (config) {
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      } else {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userInfo");
        window.location.href = "/pages/logout";
      }
      return config;
    });

    instance.interceptors.response.use(
      function (response) {
        //console.log('response :'+JSON.stringify(response))
        /*if (response.data && !response.data.status) {
                window.location.href = '/pages/login';
                return Promise.reject(response.data.message);
            }*/

        return response;
      },
      function (error) {
        console.log("error response code :" + error.response.status);
        if (error.response && 401 === error.response.status) {
          localStorage.clear();
          window.location.href = "/pages/logout";
        }
        //         window.location.href = '/pages/error-404';
        //         return Promise.reject(error);
        //     }
      }
    );
  }

  return instance;
};
